import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../Store';

import { Card, Row, Col } from 'react-bootstrap';

import { getConfigForComponent, TeleScript, BoxedContent } from 'sg-ui-components';

export class ExpiredSweepstakes extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showAll: false };
    }

    render() {
        //* Component setup
        const title = this.props.title ?? 'Expired Promotions';
        const promotionsExpiredSweepstakes = getConfigForComponent('promotionsExpiredSweepstakes', this.props.config);
        const mode = promotionsExpiredSweepstakes?.mode ?? 'show-all';
        const displayCount = promotionsExpiredSweepstakes?.options?.limit ?? 3;
        const telescript = promotionsExpiredSweepstakes?.telescript;
        const { showAll } = this.state;

        //* Validation check
        const valid = this.props.sweep.sweeps && Array.isArray(this.props.sweep.sweeps) && this.props.sweep.sweeps.length;
        if (!valid) return null;

        const expiredSweeps = this.props.sweep.sweeps
            .filter((sweep) => sweep.category === 'expired')
            .sort((a, b) => {
                return a.rank - b.rank;
            });

        const sweepsToShow = mode === 'show-limited' && !showAll ? expiredSweeps.slice(0, displayCount) : expiredSweeps;

        return (
            <>
                <BoxedContent hasCollapser={false} variant='theme-purple' title={title} isActive={true} note='Expired Promotions' hash='expired-promotions'>
                    <Row>
                        {sweepsToShow.map(({ id, name, extra }) => {
                            const description = extra?.short_description || extra?.description;
                            return id && name && extra && extra.image && description ? (
                                <Col lg={4} className='my-3' key={id}>
                                    <Card className='sweepstake-item'>
                                        <Card.Img variant='top' src={extra.image} className='cover-image' />
                                        <Card.Body>
                                            <Card.Title>{name}</Card.Title>
                                            <Card.Text>
                                                <div dangerouslySetInnerHTML={{ __html: description }}></div>
                                            </Card.Text>
                                            <a href={`promotion?id=${id}`} className='float-right'>
                                                More Info &gt;
                                            </a>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ) : null;
                        })}
                    </Row>
                    {mode === 'show-limited' && !showAll && expiredSweeps?.length > displayCount && (
                        <div className='show-more-section text-center'>
                            <button
                                type='button'
                                className='btn theme-btn theme-outline'
                                onClick={() => {
                                    this.setState({ showAll: true });
                                }}>
                                <TeleScript line={telescript?.view_more}>View more</TeleScript>
                            </button>
                        </div>
                    )}
                </BoxedContent>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExpiredSweepstakes);
